import { UserProfile } from "@clerk/react";

import { hasClerkPublishableKey } from "../../cloud/publicConfig";
import { useMorrowClerkAuth } from "./morrowClerkAuth";
import { MorrowClerkProfileAvatarPortal } from "./MorrowClerkProfileAvatarPortal";
import { morrowClerkUserProfileAppearance } from "./morrowClerkUserProfileAppearance";

/** Registers Clerk Manage account pages and injects DiceBear avatar into Update profile. */
export function MorrowClerkUserProfileHost() {
  const { isSignedIn } = useMorrowClerkAuth();

  if (!hasClerkPublishableKey() || !isSignedIn) return null;

  return (
    <>
      <div aria-hidden className="fixed size-0 overflow-hidden opacity-0">
        <UserProfile routing="hash" appearance={morrowClerkUserProfileAppearance}>
          <UserProfile.Page label="account" />
          <UserProfile.Page label="security" />
        </UserProfile>
      </div>
      <MorrowClerkProfileAvatarPortal />
    </>
  );
}
